import { createSlice } from '@reduxjs/toolkit';
import { initAddConflictObj } from '../data/type';

//Sliceの作成
export const addConflictSlice = createSlice({
    name: 'addConflict',
    //初期State(Typeからインポート)
    initialState: {
        obj: initAddConflictObj,
    },

    //toolKitを利用した値変更処理
    reducers: {
        setAddConflict: (state, action) => {
            state.obj = action.payload;
        },
        setConflictDrawingEditFlag: (state, action) => {
            state.obj.drawingEditFlag = action.payload;
        },
    },
});

export const {
    setAddConflict,
    setConflictDrawingEditFlag
} = addConflictSlice.actions;
export default addConflictSlice.reducer;